<template>
  <div class="pa-8" :class="$vuetify.breakpoint.xsOnly && 'px-4'">
    <v-overlay :value="isLoading" style="text-align: center">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
      <div style="position: relative; text-align: justify" class="mt-4">
        {{ $t("SPEAKERFORM.saving_speaker") }}
      </div>
    </v-overlay>

    <v-card class="mt-8" :class="formMargin">
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title style="justify-content: center">{{
          $t("SPEAKERFORM.title")
        }}</v-toolbar-title>
      </v-toolbar>
      <v-row class="pa-0 px-3">
        <v-col cols="12" class="pa-0 view-tab-col" xl="3" lg="2" md="3" sm="4">
          <v-tabs class="view-tab-horizontal" v-model="viewTab">
            <v-tab id="editspeaker-info-tab">
              <v-icon left> {{ mdiAccount }} </v-icon>
              {{ $t('SPEAKERFORM.info')}}
            </v-tab>
            <v-tab id="editspeaker-bio-tab">
              <v-icon left> {{ mdiTextAccount }} </v-icon>
              {{ $t('SPEAKERFORM.bio')}}
            </v-tab>
          </v-tabs>

          <v-tabs class="view-tab-vertical" v-model="viewTab" vertical left>
            <v-tab id="editspeaker-info-tab">
              <v-icon left> {{ mdiAccount }} </v-icon>
              {{ $t('SPEAKERFORM.info')}}
            </v-tab>
            <v-tab id="editspeaker-bio-tab">
              <v-icon left> {{ mdiTextAccount }} </v-icon>
              {{ $t('SPEAKERFORM.bio')}}
            </v-tab>
          </v-tabs>
        </v-col>

        <v-col cols="12" class="py-0 px-0" xl="9" lg="10" md="9" sm="8">
          <v-tabs-items v-model="viewTab">
            <v-tab-item>
              <v-row class="pa-0 ma-0" justify="center" align="center">
                <v-col cols="12" sm="3" class="text-center">
                  <v-avatar
                    :size="
                      ['lg', 'xl'].includes($vuetify.breakpoint.name)
                        ? 180
                        : 120
                    "
                    color="grey"
                  >
                    <img
                      v-if="imageAsURL"
                      class="speaker-image-preview"
                      :src="imageAsURL"
                      alt="Speaker Image"
                    />
                    <v-icon
                      v-else
                      :size="
                        ['lg', 'xl'].includes($vuetify.breakpoint.name)
                          ? 120
                          : 70
                      "
                      dark
                    >
                      {{ mdiAccount }}
                    </v-icon>
                  </v-avatar>
                </v-col>
                <v-col
                  class="pa-10 pl-3 pb-3"
                  :class="$vuetify.breakpoint.xsOnly && 'px-4'"
                  cols="12"
                  sm="9"
                >
                  <v-form
                    ref="speakerForm"
                    v-model="valid"
                    @submit.prevent
                    lazy-validation
                  >
                    <v-text-field
                      v-model="speaker.name"
                      :label="$t('SPEAKERFORM.form.name')"
                      :rules="[(v) => !!v || 'Name is required!']"
                      outlined
                      required
                    ></v-text-field>

                    <v-text-field
                      v-model="speaker.email"
                      :label="$t('SPEAKERFORM.form.email')"
                      :rules="[(v) => !!v || 'Email is required']"
                      outlined
                      required
                    ></v-text-field>

                    <v-file-input
                      v-model="imageInput"
                      :prepend-inner-icon="mdiPaperclip"
                      :prepend-icon="null"
                      @change="readUrl"
                      :label="$t('SPEAKERFORM.form.image')"
                      outlined
                      accept="image/*"
                      clearable
                    ></v-file-input>
                  </v-form>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-tabs v-model="langTab">
                  <v-tab id="editspeaker-bio-en-tab">English</v-tab>
                  <v-tab id="editspeaker-bio-pt-tab">Português</v-tab>
                  <v-tab id="editspeaker-bio-es-tab">Español</v-tab>
                </v-tabs>
                <v-divider></v-divider>

                <!---START FORM---->

                <v-card flat class="pt-5 px-5">
                  <v-tabs-items v-model="langTab">
                    <v-tab-item v-for="lang in langs" :key="lang">
                      <v-textarea
                        v-if="speaker.bio"
                        v-model="speaker.bio[lang]"
                        outlined
                        :label="$t('SPEAKERFORM.bio')"
                      ></v-textarea>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-card>

    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          id="editspeaker-save-button"
          v-on="on"
          @click="saveSpeaker()"
          color="#FBBD21"
          dark
          fab
          fixed
          bottom
          right
        >
          <v-icon>{{ mdiContentSave }}</v-icon>
        </v-btn>
      </template>

      <span>{{ $t("SPEAKERFORM.save") }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  mdiAccount,
  mdiPaperclip,
  mdiTextAccount,
  mdiContentSave,
} from "@mdi/js";

export default {
  name: "Speaker",
  data: () => ({
    valid: true,
    edit: false,
    speaker: {},
    imageInput: [],
    imageAsURL: null,
    changedImage: false,
    isLoading: false,
    mdiAccount,
    mdiPaperclip,
    mdiTextAccount,
    mdiContentSave,
    langs: ["en", "pt", "es"],
    viewTab: 0,
    langTab: 0,
  }),
  async created() {
    let speakerId = this.$route.params.speakerId;
    if (speakerId) {
      this.edit = true;
      const spkr = await this.$store.dispatch("getSpeakerById", speakerId);
      this.speaker = { ...spkr };

      if (!this.speaker.bio) {
        // add bio to speaker
        this.speaker = Object.assign(this.speaker, {
          bio: { en: "", pt: "", es: "" },
        });
      }

      if (spkr.image) {
        this.imageAsURL = spkr.image;
      }
    } else {
      this.edit = false;
      this.speaker = {
        name: "",
        email: "",
        image: "",
        bio: {
          en: "",
          pt: "",
          es: "",
        },
      };
    }
  },
  computed: {
    ...mapGetters(["speakers"]),
    formMargin() {
      const bp = this.$vuetify.breakpoint.name;

      if (bp === "sm") {
        return "mx-2";
      } else if (bp === "xs") {
        return "mx-0";
      } else {
        return "mx-16";
      }
    },
  },
  methods: {
    cancelButton() {
      this.$emit("close");
      this.$refs.speakerForm.reset();
    },

    readUrl(imageFile) {
      if (imageFile) {
        if (!imageFile.type.match(/image.*/)) {
          this.$store.dispatch("setSnackbar", {
            show: true,
            text: "The file is not an image!",
            color: "warning",
          });
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          this.changedImage = true;
          this.imageAsURL = e.target.result;
        };
        reader.readAsDataURL(imageFile);
      } else {
        this.imageAsURL = this.speaker.image || null;
      }
    },

    async createSpeaker() {
      this.isLoading = true;

      let payload = {
        name: this.speaker.name,
        email: this.speaker.email,
        bio: this.speaker.bio,
      };

      let response = await this.$store.dispatch("createSpeaker", payload);
      if (Object.keys(response).length !== 0) {
        this.$store.dispatch("setSnackbar", {
          show: true,
          text: "Success on speaker creation",
          color: "success",
        });

        let imageUrl = "";

        if (this.changedImage) {
          imageUrl = await this.$store.dispatch("uploadSpeakerImage", {
            file: this.imageInput,
            name: response.id,
          });
        }

        const updatePayload = {
          id: response.id,
          data: {
            ...payload,
            image: imageUrl,
          },
        };

        this.$store.dispatch("updateSpeaker", updatePayload);

        this.isLoading = false;
      } else {
        this.isLoading = false;
        this.$store.dispatch("setSnackbar", {
          show: true,
          text: "Oops... Error on speaker creation",
          color: "error",
        });
      }
    },

    async editSpeaker() {
      this.isLoading = true;

      let payload = {
        id: this.$route.params.speakerId,
        data: this.speaker,
      };

      if (this.changedImage) {
        payload.data.image = await this.$store.dispatch("uploadSpeakerImage", {
          file: this.imageInput,
          name: payload.id,
        });
      }

      try {
        await this.$store.dispatch("updateSpeaker", payload);
        this.$store.dispatch("setSnackbar", {
          show: true,
          text: "Success on speaker updating",
          color: "success",
        });
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.error("Error on speaker updating");
        this.$store.dispatch("setSnackbar", {
          show: true,
          text: "Oops... Error on speaker updating",
          color: "error",
        });
      }
    },

    async saveSpeaker() {
      if (this.$refs.speakerForm.validate()) {
        this.edit ? await this.editSpeaker() : await this.createSpeaker();
        this.$router.push("/dashboard/speaker");
      }
    },
  },
  watch: {
    imageAsURL(val) {
      if (!val || val === this.speaker.image) {
        this.changedImage = false;
      }
    },
  },
};
</script>

<style scoped>
.speaker-image-preview {
  width: 100%;
  height: 100%;

  object-fit: cover;
}

.view-tab-horizontal {
  display: none;
}

.view-tab-vertical {
  display: initial;
}

.view-tab-vertical #editspeaker-info-tab,
.view-tab-vertical #editspeaker-bio-tab {
  justify-content: flex-start;
  background-color: #f5f5f5;
}

.v-tab {
  width: 100% !important;
}

.view-tab-col {
  background-color: #f5f5f5;
}

@media (max-width: 600px) {
  .view-tab-horizontal {
    display: initial;
  }

  .view-tab-vertical {
    display: none;
  }
}
</style>
